import { getRequest } from "./config/request";
const SERVICE_URL = "/batch";

export const getNextBatchRunTime = () => getRequest(`${SERVICE_URL}/next`);
export const getBatches = (client) =>
  getRequest(`${SERVICE_URL}/client/${client}`);

export default { getNextBatchRunTime, getBatches };
